<template>
  <div v-if="isOpened" class="sub-page eula-container">
    <header class="p2">
      Conditions Générales d'Utilisation
    </header>
    <main>
      <div ref="EulaContent" v-scroll-bottom="enableButton" class="eula-acceptance">
        <div class="eula-acceptance__header">
          <h1 class="header__title">Conditions Générales d'Utilisation</h1>
          <p class="header__date">Dernière mise à jour : {{ eula.published_at | frenchDateFull }}</p>
        </div>
        <div class="eula-acceptance__content" v-html="eula.content" />
      </div>
      <div class="flex justify-center items-center">
        <button type="button"
                class="ev-btn primary"
                :disabled="!isValidable"
                @click="accept">
          J'ai lu et j'accepte
        </button>
      </div>
    </main>
  </div>
</template>

<script>
import apis from '@/apis';
import { frenchDateFull } from '@/filters/filtersDates';
import scrollBottom from '@/directives/scrollBottom.js';
import notify from '@/utils/notifier';

export default {
  name: 'EulaAcceptance',
  filters: {
    frenchDateFull,
  },
  directives: {
    scrollBottom,
  },
  data() {
    return {
      isOpened: false,
      isValidable: false,
      eula: null,
    };
  },
  created() {
    this.checkLastUnacceptedVersion();
  },
  mounted() {
    this.$watch('eula', () => {
      const hasScrollableContent = this.hasScrollableContent();
      if (!hasScrollableContent) {
        this.enableButton();
      }
    });
  },
  methods: {
    checkLastUnacceptedVersion() {
      apis.Eula.getVersionToAccept()
        .then(({ data: response }) => {
          if (response.id) {
            this.eula = response;
            this.isOpened = true;
          }
        });
    },
    accept() {
      apis.Eula.accept(this.eula.id)
        .then(() => {
          notify.success('Les CGU ont bien été acceptées.');
        })
        .catch(() => {
          notify.alert(
            'Une erreur s\'est produite. '
            + 'Les CGU vous seront représentées ultérieurement.',
            { durations: { global: 5000 } },
          );
        })
        .finally(() => {
          setTimeout(() => {
            this.isOpened = false;
          }, 1000);
        });
    },
    enableButton() {
      this.isValidable = true;
    },
    hasScrollableContent() {
      const eulaContent = this.$refs.EulaContent;
      const hasScrollableContent = eulaContent.scrollHeight > eulaContent.clientHeight;

      const overflowYStyle = window.getComputedStyle(eulaContent).overflowY;
      const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

      return hasScrollableContent && !isOverflowHidden;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/helpers/_sub-page';

.eula-acceptance {
  max-height: 75vh;
  overflow-y: auto;
  background-color: $varient-background-color;
  margin: 20px;

  .eula-acceptance__header {
    margin: 0 0 20px 0;
    .header__title {
      font-size: 2rem;
      font-weight: $font-weight-bold;
      margin-bottom: 5px;
    }
    .header__date {
      font-size: 1rem;
    }
  }
  .eula-acceptance__content {
    font-size: 1rem;
    margin: 30px 10px 0 0;
    white-space: break-spaces;
  }
}
</style>
